// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tKb6","col":"styles_col__2Rmjy"};